import { motion } from "framer-motion";
import { Cloud, Eye, Languages, Stethoscope } from "lucide-react";

const ITEMS = [
  { icon: Cloud, title: "Cloud-native deployment", desc: "Horizontal autoscaling on AWS/Azure with GPU inference pods and SOC2-ready logging." },
  { icon: Eye, title: "Explainable AI (XAI)", desc: "Grad-CAM overlays and attention maps to show the clinician exactly what the model saw." },
  { icon: Languages, title: "Multi-language reports", desc: "Automated translation of the medical summary to 12+ languages for field deployments." },
  { icon: Stethoscope, title: "Telemedicine integration", desc: "Direct handoff into video consultations and EHR systems via HL7/FHIR." },
];

export default function FutureScope() {
  return (
    <section id="future" className="py-24 md:py-32 bg-slate-50">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <div className="text-xs uppercase tracking-[0.22em] font-bold text-slate-500">
            <span className="font-mono-num">07</span> · Roadmap
          </div>
          <h2 className="font-heading mt-4 text-4xl sm:text-5xl tracking-tight font-light text-slate-900">
            What we're <em className="not-italic text-slate-400">building next</em>.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 gap-5">
          {ITEMS.map((it, i) => {
            const Icon = it.icon;
            return (
              <motion.div
                key={it.title}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.55, delay: i * 0.06 }}
                className="group flex gap-5 p-7 rounded-2xl bg-white border border-slate-200 hover:border-slate-300 hover:shadow-lg transition"
              >
                <div className="flex-shrink-0 h-12 w-12 rounded-xl bg-gradient-to-br from-sky-100 to-emerald-100 flex items-center justify-center">
                  <Icon className="h-5 w-5 text-slate-700" />
                </div>
                <div className="flex-1">
                  <div className="flex items-center gap-2">
                    <h3 className="font-heading text-xl text-slate-900">{it.title}</h3>
                    <span className="text-[9px] font-mono-num tracking-wider uppercase bg-slate-100 text-slate-500 px-2 py-0.5 rounded-full">
                      Planned
                    </span>
                  </div>
                  <p className="mt-1.5 text-slate-600">{it.desc}</p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
